import { m } from '@/locale/paraglide/messages';
import { createFileRoute } from '@tanstack/react-router';
import Container from '@/components/layout/container';
import { DashboardHeader } from '@/components/layout/dashboard-header';
import { ContactFormCard } from '@/components/contact/contact-form-card';
import { websiteConfig } from '@/config/website';
import { seo } from '@/lib/seo';

export const Route = createFileRoute('/(pages)/contact')({
  head: () =>
    seo('/contact', {
      title: `${m.contact_title()} | ${websiteConfig.metadata?.name}`,
      description: m.contact_description(),
    }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <div className="flex min-h-svh flex-col">
      <DashboardHeader showBack />
      <Container className="py-16 px-4">
        <div className="mx-auto max-w-4xl space-y-8 pb-16">
          <div className="space-y-4">
            <h1 className="text-center text-3xl font-bold tracking-tight">
              {m.contact_title()}
            </h1>
            <p className="text-center text-lg text-muted-foreground">
              {m.contact_description()}
            </p>
          </div>
          <ContactFormCard />
        </div>
      </Container>
    </div>
  );
}
